import React, { useEffect, useState } from "react";

export enum StampOption {
  CORRECT,
  INCORRECT,
}

interface StampProps {
  stampName: StampOption;
}

const STAMP_MAPPINGS = {
  [StampOption.CORRECT]: {
    src: "/assets/trivia/correct_stamp.png",
    alt: "Correct Answer Stamp",
  },
  [StampOption.INCORRECT]: {
    src: "/assets/trivia/wrong_stamp.png",
    alt: "Wrong Answer Stamp",
  },
};

export default function Stamp({ stampName }: StampProps) {
  const [stampMapping, setStampMapping] = useState<{
    src: string;
    alt: string;
  } | null>(null);

  useEffect(() => {
    setStampMapping(STAMP_MAPPINGS[stampName]);
  }, [stampName]);

  return stampMapping ? (
    <div className="absolute top-1/2 transform -translate-y-1/2 h-60 flex items-center justify-center z-50">
      <img src={stampMapping?.src} alt={stampMapping?.alt} />
    </div>
  ) : (
    <></>
  );
}
